import { render, staticRenderFns } from "./videoxq.vue?vue&type=template&id=725876dc&scoped=true"
import script from "./videoxq.vue?vue&type=script&lang=js"
export * from "./videoxq.vue?vue&type=script&lang=js"
import style0 from "./videoxq.vue?vue&type=style&index=0&id=725876dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725876dc",
  null
  
)

export default component.exports